import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { mixPanelEvent } from '@features/activities/data';
import { RecommendedProduct } from 'app/core/domain/recommendation.model';
import { LocalizedComponent } from 'app/presentation/base/localized.component';
import { dateFormat } from 'app/presentation/shared/constants';
import { RecommendationsPresenter } from './presenter/recommendations.presenter';
import { RecommendationsViewState } from './presenter/recommendations.viewState';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss'],
  providers: [RecommendationsPresenter],
  standalone: true,
  imports: [NgIf, NgFor, DatePipe, RouterLink],
})
export class RecommendationsComponent extends LocalizedComponent implements OnInit {
  viewState: RecommendationsViewState;

  dateFormat = dateFormat;

  constructor(private presenter: RecommendationsPresenter) {
    super();
  }

  ngOnInit(): void {
    this.presenter.viewState$.subscribe((state) => {
      this.viewState = state;
    });
    this.presenter.emitViewEvent({ type: 'Init' });
  }

  openCreativeLink(sku: string, url: string): void {
    mixPanelEvent('view_creative_link', { 'Product Id': sku, link: url });
    window.open(url, '_blank');
  }

  toggleCatalog(product: RecommendedProduct): void {
    this.presenter.emitViewEvent({ type: 'ToggleCatalog', product });
  }

  viewAllRecommendations(): void {
    this.presenter.emitViewEvent({ type: 'ViewAllRecommendations' });
  }

  trackViewProduct(sku: string): void {
    mixPanelEvent('view_recommended_product', { 'Product Id': sku });
  }
}
